<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="btn">
			<!-- <div class="jiams tj">
				<div>请选择设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div> -->
			<!-- <div class="comm tj">
				<div>请选择药品：</div>
				<Select v-model="query.comms" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in comms" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div> -->
			<!-- <div class="time tj">
				<div>请选择时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model="kaishi" style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model="jieshu" style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div> -->
		</div>
		<div class="tongji">
			<div class="item">
				<div class="item-title">商品种类：</div>
				<div class="item-title">{{map.zl}}</div>
			</div>
			<div class="item">
				<div class="item-title">商品数量：</div>
				<div class="item-title">{{map.number}}</div>
			</div>
			<div class="item">
				<div class="item-title">总金额：</div>
				<div class="item-title">{{map.money/100}}元</div>
			</div>
		</div>

		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
			<!-- 	<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> -->
			</template>
		</Table>
		<!-- <div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div> -->
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//药品列表
				comms: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: '订单id',
						key: 'orderId'
					},
					{
						title: '设备id',
						key: 'macLeaveFactoryId'
					},
					{
						title: '货道编号',
						key: 'macLeaveFactoryAisleNumber'
					},
					{
						title: '药品名称',
						key: 'commodityName'
					},
					{
						title: '条形码',
						key: 'barCode'
					},
					{
						title: '规格',
						key: 'specification'
					},
					{
						title: '生产厂家',
						key: 'operCommManu'
					},
					{
						title: '应出数量',
						key: 'number'
					},
					{
						title: '已出数量',
						key: 'shipmentNUmber'
					},
					{
						title: '售价',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div",params.row.sellPrice/100)
						}
					},
					// {
					// 	title: '进价',
					// 	key: 'purchasingPrice',
					// 	render: (h, params) => {
					// 		return h("div",params.row.purchasingPrice/100)
					// 	}
					// },
					{
						title: '总金额',
						key: 'money',
						render: (h, params) => {
							return h("div",params.row.sellPrice*params.row.number/100)
						}
					},
					
					// {
					// 	title: '是否退款',
					// 	key: 'money',
					// 	render: (h, params) => {
					// 		if(params.row.isrefund==null){
					// 			return h("div","正常")
					// 		}else{
								
					// 			switch (params.row.isrefund){
					// 				case '1':
					// 			        return h("div",{
					// 						style: {
					// 						             color: '#F7F709'
					// 						          }
					// 					},"正在退款")
					// 					break;
					// 				case '2':
					// 			        return h("div",{
					// 						style: {
					// 						             color: '#00FF66'
					// 						          }
					// 					},"已退款")
					// 					break;
					// 				default:
					// 				return h("div","未退款")
					// 					break;
					// 			}
					// 		}
					// 	}
					// },
					
					{
						title: '退款金额',
						key: 'refundMoney',
						render: (h, params) => {
							return h("div",params.row.refundMoney/100)
						}
					},
					/* {
						title: '操作',
						slot: 'action',
						width: 80,
						align: 'center'
					} */
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '50',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[],//设备信息id
					comms:[],//药品id,
					orderId:''
				},
				map:{
					zl:0,
					number:0,
					money:0
				}
			}
		},
		methods: {
			
			ret() { //返回上一页
				this.$router.back()
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				_this.query.page=0
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
					}) 
					_this.ajaxPage()
					_this.queryOperStatistics()
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo(){
				
				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			aisle(row) { //货道药品信息
				this.$router.push({
					name: 'oper/mac/aisle/list',
					query: {
						id: row.id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/queryOrderDetails',
				    data: {
						id:_this.query.orderId
					},
					_this: _this,
					success: function(data) {
						_this.data6 = data.queryOrderDetails
						
						_this.loading = false
						for (let i = 0; i < _this.data6.length; i++) {
							let a=_this.data6[i]
							_this.map.zl+=1
							_this.map.number+=a.number
							_this.map.money+=a.sellPrice*a.number
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			// queryOperStatistics(){
			// 	let _this=this
			// 	http.http({
			// 	    //这里是你自己的请求方式、url和data参数
			// 	    method: 'post',
			// 	    url: http.url + '/fin/report/comm/page/oper/statistics',
			// 	    data: _this.query,
			// 		_this: _this,
			// 		success: function(data) {
			// 				_this.map = data.map
			// 		}
			// 	    //假设后台需要的是表单数据这里你就可以更改
			// 	  })
				
			// },
			queryMacs(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let items = data.macFaultDetailss.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].macCode
							_this.macs.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryComms(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComMerchandise/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let items = data.page.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].name
							_this.comms.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}

		},
		components: {
			page
		},
		created() {
			let _this=this
			this.query.orderId=this.$route.query.orderId
			
			this.ajaxPage()
			//this.queryOperStatistics()
			//this.queryMacs()
			//this.queryComms()
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}, 
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/finance/list1.vue